import ProjectsRoutes from './routes'

const Projects = () => (
  <ProjectsRoutes />
)

export default Projects
